import {Component, EventEmitter, OnInit, Output} from '@angular/core';
import {DipRegistrationLoggingNames} from '../../core/enum/dip-registration-logging-names.enum';
import {DiprsSpaLoggerService} from '../../core/services/logger/diprs-spa-logger.service';
import { LoggerEventEnum } from '../../core/models/dip-registration-log-information.model';

@Component({
    selector: 'dip-registration-phone-number-modal',
    templateUrl: './dip-registration-phone-number-modal.component.html',
    styleUrls: ['./dip-registration-phone-number-modal.component.scss'],
    standalone: false
})
export class DipRegistrationPhoneNumberModalComponent implements OnInit {
  @Output() close = new EventEmitter<void>();
  constructor(
    private spaLoggerService: DiprsSpaLoggerService
  ) { }

  ngOnInit() {
  }

  closeBtnClick() {
    this.spaLoggerService.info(LoggerEventEnum.USER_ACTION, DipRegistrationLoggingNames.PHONE_NUMBER_POPUP, { id: 'CLOSE'});
    this.close.emit();
  }

}
